export const SWAP_TOKEN_FLAGS = {
  IN: "tokenIn",
  OUT: "tokenOut",
} as const
